export const text = {
  title: 'Opciones de producto (no obligatorio)',
  subtitle:
    'Puedes agregar variantes como tamaño, color, sabor, material, etc.',
  textToogle: 'Este producto tiene opciones',
  addAtribute: 'Agregar opción'
};
